import { FilterType } from "@/lib/filters";
import { useInfiniteQuery } from "@tanstack/react-query";
import { ReadRoleBasedProjectRates } from "@/schemas/roleBasedProjectRates";
import { keepPreviousData } from "@tanstack/react-query";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";
import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { FetchListRequest } from "@/services/api";
import { RoleBasedProjectRatesService } from "@/services/roleBasedProjectRatesService";

export const useProjectRateListQuery = () => {
  const name = "projectRates";
  const projectId = useProjectId();
  const options = useCreateDataTableOptions<ReadRoleBasedProjectRates>(name);
  const queryKey = useDynamicQueryParams(name, options);

  const fetchList = (
    fetchParams: FetchListRequest<ReadRoleBasedProjectRates>,
  ) => RoleBasedProjectRatesService.getList(fetchParams);

  const listQuery = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      fetchList({
        lastItem: pageParam,
        filters: [
          ...options.filters,
          {
            id: "project_id",
            value: {
              value: projectId,
              filter: FilterType.IncludesString,
            },
          },
        ],
        sorting: options.sorting[0],
      }),
    initialPageParam: undefined,
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  });

  return { listQuery, options };
};
